var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 40,
    viewBox: "0 0 111 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_499_1628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9759 32.986C15.3244 32.986 15.6069 33.2713 15.6069 33.6232C15.6069 33.9751 15.3244 34.2604 14.9759 34.2604C14.6274 34.2604 14.3449 33.9751 14.3449 33.6232C14.3449 33.2713 14.6274 32.986 14.9759 32.986Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8102 35.2799C24.1587 35.2799 24.4413 35.5651 24.4413 35.917C24.4413 36.2689 24.1587 36.5542 23.8102 36.5542C23.4617 36.5542 23.1792 36.2689 23.1792 35.917C23.1792 35.5651 23.4617 35.2799 23.8102 35.2799Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3057 28.3983C23.6542 28.3983 23.9367 28.6836 23.9367 29.0355C23.9367 29.3874 23.6542 29.6726 23.3057 29.6726C22.9572 29.6726 22.6747 29.3874 22.6747 29.0355C22.6747 28.6836 22.9572 28.3983 23.3057 28.3983Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0437 20.2424C22.3922 20.2424 22.6747 20.5277 22.6747 20.8796C22.6747 21.2315 22.3922 21.5168 22.0437 21.5168C21.6952 21.5168 21.4127 21.2315 21.4127 20.8796C21.4127 20.5277 21.6952 20.2424 22.0437 20.2424Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1206 21.262C30.4691 21.262 30.7516 21.5473 30.7516 21.8992C30.7516 22.2511 30.4691 22.5363 30.1206 22.5363C29.7721 22.5363 29.4896 22.2511 29.4896 21.8992C29.4896 21.5473 29.7721 21.262 30.1206 21.262Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8871 30.1821C32.2356 30.1821 32.5182 30.4674 32.5182 30.8193C32.5182 31.1712 32.2356 31.4564 31.8871 31.4564C31.5386 31.4564 31.2561 31.1712 31.2561 30.8193C31.2561 30.4674 31.5386 30.1821 31.8871 30.1821Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6827 22.0262C37.0312 22.0262 37.3137 22.3115 37.3137 22.6634C37.3137 23.0153 37.0312 23.3006 36.6827 23.3006C36.3342 23.3006 36.0517 23.0153 36.0517 22.6634C36.0517 22.3115 36.3342 22.0262 36.6827 22.0262Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9065 12.8514C34.255 12.8514 34.5375 13.1366 34.5375 13.4885C34.5375 13.8404 34.255 14.1257 33.9065 14.1257C33.558 14.1257 33.2755 13.8404 33.2755 13.4885C33.2755 13.1366 33.558 12.8514 33.9065 12.8514Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3245 12.5961C25.673 12.5961 25.9555 12.8813 25.9555 13.2332C25.9555 13.5851 25.673 13.8704 25.3245 13.8704C24.976 13.8704 24.6935 13.5851 24.6935 13.2332C24.6935 12.8813 24.976 12.5961 25.3245 12.5961Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.849 5.96979C28.1975 5.96979 28.48 6.25507 28.48 6.60697C28.48 6.95888 28.1975 7.24415 27.849 7.24415C27.5005 7.24415 27.218 6.95888 27.218 6.60697C27.218 6.25507 27.5005 5.96979 27.849 5.96979Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7624 5.96979C19.1109 5.96979 19.3934 6.25507 19.3934 6.60697C19.3934 6.95888 19.1109 7.24415 18.7624 7.24415C18.4139 7.24415 18.1314 6.95888 18.1314 6.60697C18.1314 6.25507 18.4139 5.96979 18.7624 5.96979Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4326 9.53795C10.7811 9.53795 11.0637 9.82323 11.0637 10.1751C11.0637 10.527 10.7811 10.8123 10.4326 10.8123C10.0842 10.8123 9.80164 10.527 9.80164 10.1751C9.80164 9.82323 10.0842 9.53795 10.4326 9.53795Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7333 14.3804C16.0818 14.3804 16.3643 14.6657 16.3643 15.0176C16.3643 15.3695 16.0818 15.6548 15.7333 15.6548C15.3848 15.6548 15.1023 15.3695 15.1023 15.0176C15.1023 14.6657 15.3848 14.3804 15.7333 14.3804Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40416 17.9486C7.75265 17.9486 8.03516 18.2338 8.03516 18.5857C8.03516 18.9376 7.75265 19.2229 7.40416 19.2229C7.05566 19.2229 6.77315 18.9376 6.77315 18.5857C6.77315 18.2338 7.05566 17.9486 7.40416 17.9486Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90872 27.124C8.25722 27.124 8.53973 27.4093 8.53973 27.7612C8.53973 28.1131 8.25722 28.3983 7.90872 28.3983C7.56022 28.3983 7.27771 28.1131 7.27771 27.7612C7.27771 27.4093 7.56022 27.124 7.90872 27.124Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7237 24.0653C15.0722 24.0653 15.3547 24.3506 15.3547 24.7025C15.3547 25.0544 15.0722 25.3397 14.7237 25.3397C14.3752 25.3397 14.0927 25.0544 14.0927 24.7025C14.0927 24.3506 14.3752 24.0653 14.7237 24.0653Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9881 32.9855L14.7685 25.3386L14.7132 25.3402L14.9328 32.9871L14.9881 32.9855Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5809 33.8067L23.192 35.7854L23.2058 35.7313L15.5947 33.7526L15.5809 33.8067Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.543 33.3421L22.764 29.3639L22.7375 29.3149L15.5165 33.2931L15.543 33.3421Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7963 35.2792L23.3786 29.6686L23.3235 29.6728L23.7412 35.2834L23.7963 35.2792Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2737 30.6701L23.9304 29.1316L23.9191 29.1863L31.2624 30.7248L31.2737 30.6701Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3375 31.1336L24.3322 35.5582L24.3616 35.6055L31.3668 31.1809L31.3375 31.1336Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7964 30.188L30.265 22.5193L30.2108 22.5304L31.7422 30.1991L31.7964 30.188Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2346 30.2866L36.3867 23.2268L36.3392 23.1983L32.187 30.2581L32.2346 30.2866Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7448 21.9911L36.0527 22.6196L36.0591 22.5641L30.7512 21.9357L30.7448 21.9911Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0637 14.1056L36.4737 22.0621L36.5266 22.0457L34.1166 14.0893L34.0637 14.1056Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6208 14.0568L30.3505 21.3049L30.4008 21.3281L33.6711 14.08L33.6208 14.0568Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.608 13.8033L29.79 21.3558L29.8383 21.3285L25.6562 13.776L25.608 13.8033Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9549 13.2779L33.275 13.498L33.2766 13.4422L25.9566 13.2221L25.9549 13.2779Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.571 12.6467L27.6518 7.21314L27.6002 7.19299L25.5194 12.6265L25.571 12.6467Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5089 12.9929L28.2857 7.06718L28.2444 7.10432L33.4676 13.03L33.5089 12.9929Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3931 6.63491H27.2177V6.57904H19.3931V6.63491Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1887 7.07701L24.859 12.8027L24.8981 12.7632L19.2279 7.0375L19.1887 7.07701Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5223 7.19686L15.9226 14.4092L15.9745 14.4283L18.5743 7.21597L18.5223 7.19686Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6981 13.3153L16.3501 14.8817L16.3602 14.9367L24.7082 13.3702L24.6981 13.3153Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0518 13.8081L22.2667 20.283L22.3175 20.3053L25.1026 13.8304L25.0518 13.8081Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.181 15.4678L21.5608 20.4678L21.5983 20.4266L16.2185 15.4266L16.181 15.4678Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.64 15.6482L14.7581 24.0655L14.8131 24.0714L15.695 15.654L15.64 15.6482Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.47 21.1464L15.2736 24.3889L15.299 24.4385L21.4954 21.196L21.47 21.1464Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.666 20.9861L29.4903 21.8514L29.4972 21.796L22.6729 20.9307L22.666 20.9861Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7643 28.5968L29.7018 22.3766L29.662 22.3379L23.7245 28.558L23.7643 28.5968Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7521 28.7284L15.3004 24.9624L15.2756 25.0124L22.7273 28.7783L22.7521 28.7284Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.497 27.5286L14.159 24.9878L14.1365 24.9368L8.47453 27.4775L8.497 27.5286Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37802 28.1883L14.4693 33.2425L14.5044 33.1994L8.41314 28.1452L8.37802 28.1883Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90591 27.1233L7.46497 19.2205L7.40973 19.2236L7.85067 27.1264L7.90591 27.1233Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2528 24.2776L7.90589 18.9726L7.87061 19.0156L14.2175 24.3207L14.2528 24.2776Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2528 24.2776L7.90589 18.9726L7.87061 19.0156L14.2175 24.3207L14.2528 24.2776Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1931 10.765L7.59282 17.9773L7.64481 17.9964L10.2451 10.7841L10.1931 10.765Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8799 10.626L15.2473 14.6104L15.2844 14.5689L10.917 10.5846L10.8799 10.626Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99812 18.3679L15.1611 15.2869L15.1394 15.2355L7.97644 18.3165L7.99812 18.3679Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0272 9.95726L18.1901 6.87625L18.1684 6.82485L11.0055 9.90586L11.0272 9.95726Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8166 0.625102C23.1651 0.625102 23.4476 0.910375 23.4476 1.26228C23.4476 1.61418 23.1651 1.89946 22.8166 1.89946C22.4681 1.89946 22.1856 1.61418 22.1856 1.26228C22.1856 0.910375 22.4681 0.625102 22.8166 0.625102Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5497 5.42957C33.8982 5.42957 34.1807 5.71484 34.1807 6.06675C34.1807 6.41865 33.8982 6.70393 33.5497 6.70393C33.2012 6.70393 32.9187 6.41865 32.9187 6.06675C32.9187 5.71484 33.2012 5.42957 33.5497 5.42957Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4141 15.8765C39.7626 15.8765 40.0451 16.1618 40.0451 16.5137C40.0451 16.8656 39.7626 17.1509 39.4141 17.1509C39.0656 17.1509 38.7831 16.8656 38.7831 16.5137C38.7831 16.1618 39.0656 15.8765 39.4141 15.8765Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.865 27.9994C38.2135 27.9994 38.496 28.2847 38.496 28.6366C38.496 28.9885 38.2135 29.2738 37.865 29.2738C37.5165 29.2738 37.234 28.9885 37.234 28.6366C37.234 28.2847 37.5165 27.9994 37.865 27.9994Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4556 36.7704C29.8041 36.7704 30.0866 37.0556 30.0866 37.4075C30.0866 37.7594 29.8041 38.0447 29.4556 38.0447C29.1071 38.0447 28.8246 37.7594 28.8246 37.4075C28.8246 37.0556 29.1071 36.7704 29.4556 36.7704Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6714 38.6698C18.0199 38.6698 18.3024 38.9551 18.3024 39.307C18.3024 39.6589 18.0199 39.9442 17.6714 39.9442C17.3229 39.9442 17.0404 39.6589 17.0404 39.307C17.0404 38.9551 17.3229 38.6698 17.6714 38.6698Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32559 33.2508C7.67409 33.2508 7.9566 33.5361 7.9566 33.888C7.9566 34.2399 7.67409 34.5252 7.32559 34.5252C6.9771 34.5252 6.69459 34.2399 6.69459 33.888C6.69459 33.5361 6.9771 33.2508 7.32559 33.2508Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.12504 22.8039C2.47354 22.8039 2.75605 23.0892 2.75605 23.4411C2.75605 23.793 2.47354 24.0782 2.12504 24.0782C1.77655 24.0782 1.49403 23.793 1.49403 23.4411C1.49403 23.0892 1.77655 22.8039 2.12504 22.8039Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72947 11.4072C4.07796 11.4072 4.36048 11.6925 4.36048 12.0444C4.36048 12.3963 4.07796 12.6816 3.72947 12.6816C3.38097 12.6816 3.09846 12.3963 3.09846 12.0444C3.09846 11.6925 3.38097 11.4072 3.72947 11.4072Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5303 2.9156C11.8788 2.9156 12.1613 3.20088 12.1613 3.55278C12.1613 3.90468 11.8788 4.18996 11.5303 4.18996C11.1818 4.18996 10.8993 3.90468 10.8993 3.55278C10.8993 3.20088 11.1818 2.9156 11.5303 2.9156Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5551 9.54961L11.4519 4.18537L11.3973 4.17607L10.5005 9.54031L10.5551 9.54961Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1899 6.33651L12.123 3.77171L12.1016 3.82324L18.1686 6.38805L18.1899 6.33651Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1915 1.35724L12.1434 3.40138L12.1543 3.45614L22.2024 1.41201L22.1915 1.35724Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4107 1.75089L19.1244 6.0844L19.1683 6.11837L22.4546 1.78485L22.4107 1.75089Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2325 1.7413L27.3935 6.16476L27.4336 6.12628L23.2726 1.70282L23.2325 1.7413Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.918 6.08867L28.4748 6.52275L28.4801 6.57835L32.9233 6.14427L32.918 6.08867Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5502 6.70447L33.8579 12.8531L33.9131 12.8503L33.6055 6.70165L33.5502 6.70447Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8746 16.1813L34.4735 13.769L34.4471 13.8181L38.8482 16.2304L38.8746 16.1813Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1361 17.086L36.9159 22.0709L36.9663 22.0939L39.1865 17.1089L39.1361 17.086Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7748 28.0048L36.8288 23.2841L36.7746 23.2952L37.7206 28.0159L37.7748 28.0048Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2603 28.8215L32.4724 30.5807L32.4913 30.6332L37.2792 28.874L37.2603 28.8215Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6962 36.8179L31.6901 31.4257L31.6383 31.4061L29.6444 36.7983L29.6962 36.8179Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8508 37.223L24.4303 36.0414L24.4162 36.0954L28.8366 37.277L28.8508 37.223Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2385 39.0259L23.2681 36.2443L23.2415 36.1953L18.2119 38.9769L18.2385 39.0259Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.423 38.72L15.2681 34.1882L15.2182 34.2124L17.3731 38.7442L17.423 38.72Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95727 33.8975L14.3462 33.6712L14.3443 33.6154L7.95533 33.8416L7.95727 33.8975Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41122 33.2561L7.8848 28.3991L7.82974 28.3936L7.35616 33.2506L7.41122 33.2561Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87329 34.2049L17.0965 39.0413L17.122 38.9917L7.89878 34.1554L7.87329 34.2049Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.06539 33.3067L2.43191 23.9983L2.38248 24.0234L7.01595 33.3318L7.06539 33.3067Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41563 27.3627L2.64717 23.799L2.61426 23.844L7.38272 27.4076L7.41563 27.3627Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91969 18.9953L2.57336 22.9919L2.61061 23.0332L6.95694 19.0366L6.91969 18.9953Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61578 12.6717L2.1823 22.8053L2.23707 22.8132L3.67054 12.6796L3.61578 12.6717Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01744 12.6118L7.06917 18.0448L7.11729 18.0172L4.06556 12.5843L4.01744 12.6118Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34655 11.9071L9.83147 10.3696L9.81668 10.3158L4.33175 11.8532L4.34655 11.9071Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17685 11.5947L11.1207 4.03827L11.0801 4.00026L4.1363 11.5567L4.17685 11.5947Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4274 17.7092C17.9468 17.7092 18.3679 18.1344 18.3679 18.6589C18.3679 19.1834 17.9468 19.6087 17.4274 19.6087C16.908 19.6087 16.4869 19.1834 16.4869 18.6589C16.4869 18.1344 16.908 17.7092 17.4274 17.7092Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.267 11.7316C29.7864 11.7316 30.2075 12.1568 30.2075 12.6813C30.2075 13.2058 29.7864 13.631 29.267 13.631C28.7475 13.631 28.3264 13.2058 28.3264 12.6813C28.3264 12.1568 28.7475 11.7316 29.267 11.7316Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3029 26.983C27.7765 26.983 28.1604 27.3706 28.1604 27.8489C28.1604 28.3271 27.7765 28.7148 27.3029 28.7148C26.8293 28.7148 26.4454 28.3271 26.4454 27.8489C26.4454 27.3706 26.8293 26.983 27.3029 26.983Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9253 21.0612C38.3989 21.0612 38.7829 21.4489 38.7829 21.9271C38.7829 22.4053 38.3989 22.793 37.9253 22.793C37.4517 22.793 37.0678 22.4053 37.0678 21.9271C37.0678 21.4489 37.4517 21.0612 37.9253 21.0612Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 32.4019C33.8069 32.4019 34.1909 32.7896 34.1909 33.2679C34.1909 33.7461 33.8069 34.1338 33.3333 34.1338C32.8597 34.1338 32.4758 33.7461 32.4758 33.2679C32.4758 32.7896 32.8597 32.4019 33.3333 32.4019Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2683 37.374C22.7419 37.374 23.1259 37.7617 23.1259 38.2399C23.1259 38.7182 22.7419 39.1059 22.2683 39.1059C21.7947 39.1059 21.4108 38.7182 21.4108 38.2399C21.4108 37.7617 21.7947 37.374 22.2683 37.374Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9267 36.145C11.4003 36.145 11.7842 36.5327 11.7842 37.0109C11.7842 37.4891 11.4003 37.8768 10.9267 37.8768C10.4531 37.8768 10.0692 37.4891 10.0692 37.0109C10.0692 36.5327 10.4531 36.145 10.9267 36.145Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9599 27.374C3.4335 27.374 3.81743 27.7617 3.81743 28.2399C3.81743 28.7182 3.4335 29.1059 2.9599 29.1059C2.48629 29.1059 2.10236 28.7182 2.10236 28.2399C2.10236 27.7617 2.48629 27.374 2.9599 27.374Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8368 16.4243C6.3104 16.4243 6.69434 16.812 6.69434 17.2902C6.69434 17.7685 6.3104 18.1561 5.8368 18.1561C5.36319 18.1561 4.97926 17.7685 4.97926 17.2902C4.97926 16.812 5.36319 16.4243 5.8368 16.4243Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.968195 16.2008C1.4418 16.2008 1.82573 16.5885 1.82573 17.0668C1.82573 17.545 1.4418 17.9327 0.968195 17.9327C0.49459 17.9327 0.110657 17.545 0.110657 17.0668C0.110657 16.5885 0.49459 16.2008 0.968195 16.2008Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00277 5.97736C6.47638 5.97736 6.86031 6.36505 6.86031 6.84329C6.86031 7.32152 6.47638 7.70921 6.00277 7.70921C5.52917 7.70921 5.14523 7.32152 5.14523 6.84329C5.14523 6.36505 5.52917 5.97736 6.00277 5.97736Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.906 5.64217C16.3796 5.64217 16.7635 6.02985 16.7635 6.50809C16.7635 6.98633 16.3796 7.37401 15.906 7.37401C15.4323 7.37401 15.0484 6.98633 15.0484 6.50809C15.0484 6.02985 15.4323 5.64217 15.906 5.64217Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9613 -0.000290285C16.4349 -0.000290285 16.8188 0.387396 16.8188 0.865632C16.8188 1.34387 16.4349 1.73155 15.9613 1.73155C15.4877 1.73155 15.1037 1.34387 15.1037 0.865632C15.1037 0.387396 15.4877 -0.000290285 15.9613 -0.000290285Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0816 1.56396C27.5552 1.56396 27.9391 1.95164 27.9391 2.42988C27.9391 2.90811 27.5552 3.2958 27.0816 3.2958C26.608 3.2958 26.2241 2.90811 26.2241 2.42988C26.2241 1.95164 26.608 1.56396 27.0816 1.56396Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1831 11.7281L27.3712 3.25267L27.1549 3.29983L28.9668 11.7752L29.1831 11.7281Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3209 9.32932C36.7639 9.32932 37.1231 9.69199 37.1231 10.1394C37.1231 10.5868 36.7639 10.9494 36.3209 10.9494C35.8778 10.9494 35.5187 10.5868 35.5187 10.1394C35.5187 9.69199 35.8778 9.32932 36.3209 9.32932Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4582 12.1842L16.7338 6.76293L16.6416 6.96611L28.3661 12.3873L28.4582 12.1842Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2362 2.61589L16.6766 6.11366L16.7519 6.32375L26.3116 2.82599L26.2362 2.61589Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3748 13.0032L18.221 18.1378L18.3201 18.3376L28.4739 13.203L28.3748 13.0032Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8985 7.38201L17.2064 17.7301L17.4259 17.7018L16.1181 7.35372L15.8985 7.38201Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5588 29.4969C13.0782 29.4969 13.4993 29.9221 13.4993 30.4466C13.4993 30.9712 13.0782 31.3964 12.5588 31.3964C12.0394 31.3964 11.6183 30.9712 11.6183 30.4466C11.6183 29.9221 12.0394 29.4969 12.5588 29.4969Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1924 12.4736L35.5998 10.5093L35.5249 10.299L30.1175 12.2633L30.1924 12.4736Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9215 21.0537L36.5373 10.9275L36.3181 10.958L37.7023 21.0843L37.9215 21.0537Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4148 21.2229L29.9896 13.2983L29.8289 13.4519L37.2541 21.3765L37.4148 21.2229Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5199 27.0048L29.2599 13.6383L29.0405 13.6092L27.3005 26.9757L27.5199 27.0048Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1072 27.5282L37.2275 22.4428L37.1205 22.2472L28.0002 27.3326L28.1072 27.5282Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.87 28.5078L32.6208 32.7737L32.7679 32.6067L28.0171 28.3408L27.87 28.5078Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5004 22.6875L33.5524 32.4227L33.7572 32.5074L37.7052 22.7722L37.5004 22.6875Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0984 37.9934L32.595 33.7224L32.5049 33.5183L23.0084 37.7893L23.0984 37.9934Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7411 37.5098L27.0261 28.6762L26.8273 28.5779L22.5424 37.4115L22.7411 37.5098Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6656 37.6145L13.3657 30.948L13.2279 31.1229L21.5278 37.7894L21.6656 37.6145Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.439 27.8869L13.467 30.1796L13.5051 30.3997L26.4772 28.107L26.439 27.8869Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9618 19.4919L12.8152 29.526L13.0194 29.612L17.166 19.5779L16.9618 19.4919Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.044 19.3847L26.5989 27.3428L26.7488 27.1784L18.1939 19.2203L18.044 19.3847Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5058 18.4396L6.7017 17.2781L6.67591 17.5001L16.4801 18.6615L16.5058 18.4396Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2278 29.5507L6.32404 18.011L6.12743 18.1136L12.0312 29.6532L12.2278 29.5507Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28649 27.4317L5.723 18.1557L5.5091 18.0984L3.07258 27.3744L3.28649 27.4317Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.77233 28.536L11.6169 30.345L11.6661 30.1271L3.8216 28.3182L3.77233 28.536Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4598 28.9518L10.2659 36.4484L10.429 36.2974L3.62292 28.8007L3.4598 28.9518Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2308 31.3425L11.0198 36.1414L11.2342 36.1966L12.4453 31.3977L12.2308 31.3425Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4276 38.0361L11.7911 36.9914L11.7674 37.2136L21.404 38.2583L21.4276 38.0361Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91664 27.3681L1.22425 17.9005L1.00647 17.9402L2.69886 27.4078L2.91664 27.3681Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52361 7.57007L1.25252 16.2427L1.45067 16.3422L5.72177 7.66958L5.52361 7.57007Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79852 6.50019L15.2793 1.40186L15.1661 1.20985L6.68531 6.30817L6.79852 6.50019Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2477 2.19967L16.827 0.867268L16.7963 1.08857L26.217 2.42097L26.2477 2.19967Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6706 3.06967L35.6336 9.70822L35.7745 9.53589L27.8115 2.89735L27.6706 3.06967Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2357 7.05994L6.34494 16.5845L6.50598 16.7378L15.3967 7.21322L15.2357 7.05994Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88273 7.70731L5.73612 16.423L5.95739 16.4268L6.104 7.71111L5.88273 7.70731Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86356 6.9259L15.0522 6.64155L15.0446 6.41821L6.85595 6.70257L6.86356 6.9259Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8506 1.72996L15.7953 5.64057L16.0166 5.64376L16.0719 1.73315L15.8506 1.72996Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81908 17.218L4.97427 17.3778L4.98536 17.1546L1.83017 16.9948L1.81908 17.218Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0905 39.0524L11.7594 37.2278L11.7239 37.3336L17.055 39.1582L17.0905 39.0524Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2987 39.2334L28.8365 37.5357L28.8277 37.4805L18.29 39.1783L18.2987 39.2334Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0905 39.0524L11.7594 37.2278L11.7239 37.3336L17.055 39.1582L17.0905 39.0524Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77134 34.3409L10.2394 36.4901L10.3117 36.4055L7.84361 34.2563L7.77134 34.3409Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3002 39.2245L21.4449 38.4877L21.4199 38.3788L18.2752 39.1157L18.3002 39.2245Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8218 37.4213L23.115 38.0973L23.1279 38.2083L28.8347 37.5323L28.8218 37.4213Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9291 36.9827L32.7772 33.9285L32.6967 33.8519L29.8485 36.9061L29.9291 36.9827Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3848 29.0531L33.8921 32.6079L33.9707 32.6865L37.4633 29.1318L37.3848 29.0531Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9203 27.9998L37.9806 22.7937L37.87 22.7924L37.8097 27.9985L37.9203 27.9998Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1954 17.1136L38.0895 21.0745L38.196 21.1048L39.3019 17.1439L39.1954 17.1136Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1932 15.913L36.7235 10.8421L36.6242 10.8914L39.0939 15.9624L39.1932 15.913Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8637 6.62132L35.8255 9.50065L35.9167 9.43732L33.9549 6.55799L33.8637 6.62132Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.024 5.71016L27.861 2.79675L27.807 2.89429L32.97 5.8077L33.024 5.71016Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4123 1.47819L26.24 2.2564L26.269 2.1486L23.4414 1.37039L23.4123 1.47819Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1891 1.17523L16.821 0.856234L16.8145 0.967772L22.1826 1.28676L22.1891 1.17523Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0999 3.27274L15.2545 1.35933L15.1975 1.26355L12.0429 3.17696L12.0999 3.27274Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9588 3.82928L6.71707 6.36224L6.7734 6.45841L11.0152 3.92545L10.9588 3.82928Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03123 11.4827L5.70868 7.65921L5.60751 7.61396L3.93006 11.4374L4.03123 11.4827Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37846 12.5765L1.34139 16.2855L1.43815 16.3397L3.47522 12.6307L3.37846 12.5765Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0699 22.8029L1.17142 17.9096L1.06262 17.93L1.9611 22.8233L2.0699 22.8029Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.17406 24.0795L2.76825 27.3951L2.87713 27.3752L2.28294 24.0596L2.17406 24.0795Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98076 33.3507L3.52295 28.8949L3.43585 28.9638L6.89367 33.4196L6.98076 33.3507Z",
    fill: "white",
    fillOpacity: 0.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9765 31.18C56.3965 31.18 54.9365 30.92 53.5965 30.4C52.2565 29.86 51.0965 29.11 50.1165 28.15C49.1365 27.19 48.3665 26.06 47.8065 24.76C47.2665 23.46 46.9965 22.04 46.9965 20.5C46.9965 18.96 47.2665 17.54 47.8065 16.24C48.3665 14.94 49.1365 13.81 50.1165 12.85C51.1165 11.89 52.2865 11.15 53.6265 10.63C54.9665 10.09 56.4265 9.82 58.0065 9.82C59.5265 9.82 60.9565 10.08 62.2965 10.6C63.6365 11.1 64.7665 11.86 65.6865 12.88L64.2765 14.29C63.4165 13.41 62.4665 12.78 61.4265 12.4C60.3865 12 59.2665 11.8 58.0665 11.8C56.8065 11.8 55.6365 12.02 54.5565 12.46C53.4765 12.88 52.5365 13.49 51.7365 14.29C50.9365 15.07 50.3065 15.99 49.8465 17.05C49.4065 18.09 49.1865 19.24 49.1865 20.5C49.1865 21.76 49.4065 22.92 49.8465 23.98C50.3065 25.02 50.9365 25.94 51.7365 26.74C52.5365 27.52 53.4765 28.13 54.5565 28.57C55.6365 28.99 56.8065 29.2 58.0665 29.2C59.2665 29.2 60.3865 29 61.4265 28.6C62.4665 28.2 63.4165 27.56 64.2765 26.68L65.6865 28.09C64.7665 29.11 63.6365 29.88 62.2965 30.4C60.9565 30.92 59.5165 31.18 57.9765 31.18ZM76.1504 31.18C74.5904 31.18 73.0904 30.93 71.6504 30.43C70.2304 29.91 69.1304 29.25 68.3504 28.45L69.2204 26.74C69.9604 27.46 70.9504 28.07 72.1904 28.57C73.4504 29.05 74.7704 29.29 76.1504 29.29C77.4704 29.29 78.5404 29.13 79.3604 28.81C80.2004 28.47 80.8104 28.02 81.1904 27.46C81.5904 26.9 81.7904 26.28 81.7904 25.6C81.7904 24.78 81.5504 24.12 81.0704 23.62C80.6104 23.12 80.0004 22.73 79.2404 22.45C78.4804 22.15 77.6404 21.89 76.7204 21.67C75.8004 21.45 74.8804 21.22 73.9604 20.98C73.0404 20.72 72.1904 20.38 71.4104 19.96C70.6504 19.54 70.0304 18.99 69.5504 18.31C69.0904 17.61 68.8604 16.7 68.8604 15.58C68.8604 14.54 69.1304 13.59 69.6704 12.73C70.2304 11.85 71.0804 11.15 72.2204 10.63C73.3604 10.09 74.8204 9.82 76.6004 9.82C77.7804 9.82 78.9504 9.99 80.1104 10.33C81.2704 10.65 82.2704 11.1 83.1104 11.68L82.3604 13.45C81.4604 12.85 80.5004 12.41 79.4804 12.13C78.4804 11.85 77.5104 11.71 76.5704 11.71C75.3104 11.71 74.2704 11.88 73.4504 12.22C72.6304 12.56 72.0204 13.02 71.6204 13.6C71.2404 14.16 71.0504 14.8 71.0504 15.52C71.0504 16.34 71.2804 17 71.7404 17.5C72.2204 18 72.8404 18.39 73.6004 18.67C74.3804 18.95 75.2304 19.2 76.1504 19.42C77.0704 19.64 77.9804 19.88 78.8804 20.14C79.8004 20.4 80.6404 20.74 81.4004 21.16C82.1804 21.56 82.8004 22.1 83.2604 22.78C83.7404 23.46 83.9804 24.35 83.9804 25.45C83.9804 26.47 83.7004 27.42 83.1404 28.3C82.5804 29.16 81.7204 29.86 80.5604 30.4C79.4204 30.92 77.9504 31.18 76.1504 31.18ZM97.9975 31.18C96.4175 31.18 94.9475 30.92 93.5875 30.4C92.2475 29.86 91.0775 29.11 90.0775 28.15C89.0975 27.17 88.3275 26.04 87.7675 24.76C87.2275 23.46 86.9575 22.04 86.9575 20.5C86.9575 18.96 87.2275 17.55 87.7675 16.27C88.3275 14.97 89.0975 13.84 90.0775 12.88C91.0775 11.9 92.2475 11.15 93.5875 10.63C94.9275 10.09 96.3975 9.82 97.9975 9.82C99.5775 9.82 101.037 10.09 102.377 10.63C103.717 11.15 104.877 11.89 105.857 12.85C106.857 13.81 107.627 14.94 108.167 16.24C108.727 17.54 109.007 18.96 109.007 20.5C109.007 22.04 108.727 23.46 108.167 24.76C107.627 26.06 106.857 27.19 105.857 28.15C104.877 29.11 103.717 29.86 102.377 30.4C101.037 30.92 99.5775 31.18 97.9975 31.18ZM97.9975 29.2C99.2575 29.2 100.417 28.99 101.477 28.57C102.557 28.13 103.487 27.52 104.267 26.74C105.067 25.94 105.687 25.02 106.127 23.98C106.567 22.92 106.787 21.76 106.787 20.5C106.787 19.24 106.567 18.09 106.127 17.05C105.687 15.99 105.067 15.07 104.267 14.29C103.487 13.49 102.557 12.88 101.477 12.46C100.417 12.02 99.2575 11.8 97.9975 11.8C96.7375 11.8 95.5675 12.02 94.4875 12.46C93.4075 12.88 92.4675 13.49 91.6675 14.29C90.8875 15.07 90.2675 15.99 89.8075 17.05C89.3675 18.09 89.1475 19.24 89.1475 20.5C89.1475 21.74 89.3675 22.89 89.8075 23.95C90.2675 25.01 90.8875 25.94 91.6675 26.74C92.4675 27.52 93.4075 28.13 94.4875 28.57C95.5675 28.99 96.7375 29.2 97.9975 29.2Z",
    fill: "#FDC82F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_499_1628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsoLogo);
export default __webpack_public_path__ + "static/media/CSOLogo.372d50dee333d31819c6fa0794554078.svg";
export { ForwardRef as ReactComponent };